import { FeatureConfiguration } from "..";
import { modalMessageReducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.modalMessage = modalMessageReducer;
}
